import React, { useRef, useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Form, Field } from "react-final-form";
import { classNames } from "primereact/utils";
import { Checkbox } from "primereact/checkbox";
import { useQuery } from "react-query";

import { useUser } from "../../Context/UserContext";
import { Card } from "primereact/card";
import { CreateNewUser, getUserByEmail } from "../../Data/user_service";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import fetchSecteur from "../../Data/secteur_service";
import { useSecteur } from "../../Context/SecteurContext";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import "./register.css";
import { Toast } from "primereact/toast";
import { verifToken } from "../../Data/user_service";
import { ProgressSpinner } from "primereact/progressspinner";
import { useClient } from "../../Context/ClientContext";

import { isGexMemeber } from "../../component/NavBar/navBar";


export const toLowerCase = (value) => (value ? value.toLowerCase() : "");


export const toUpperCase = (value) => (value ? value.toUpperCase() : "");
export const capitalizeFirstLetter = (value) => {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};




// Find the selected client's roles

// Password criteria component
const PasswordCriteria = ({ password }) => {
  const criteria = [
    { label: "Au moins 6 caractères", test: password.length >= 6 },
    { label: "Au moins une majuscule", test: /[A-Z]/.test(password) },
    { label: "Au moins une minuscule", test: /[a-z]/.test(password) },
    { label: "Au moins un chiffre", test: /\d/.test(password) },
    { label: "Au moins un caractère spécial", test: /[@$!%*?&]/.test(password) },
  ];
  return (
    <div>
      <p>Le mot de passe doit respecter les critères suivants:</p>
      <ul style={{ listStyleType: "none", padding: 0 }}>
        {criteria.map((criterion, index) => (
          <li key={index} style={{ color: criterion.test ? "green" : "red" }}>
            {criterion.test ? '✓' : '✗'} {criterion.label}
          </li>
        ))}
      </ul>
    </div>
  );
};




function InterfaceRegistration() {
  const search = useLocation().search;
  //const email = new URLSearchParams(search).get("email");
  const email = new URLSearchParams(search.replace(/\+/g, "%2B")).get("email") || "";
  const { user, setUserAttributes } = useUser();
  const { secteurs, setSecteurAttributes } = useSecteur();
  const navigate = useNavigate();
  const { utilisateurId, token } = useParams();
  const toast = useRef(null);
  const [password, setPassword] = useState(""); // For live password feedback
    const {client , selectedClient}=useClient()
  
   const clientTableau = Object.values(client);

    const [isMember, setIsMember] = useState(false);

  useQuery("userData", () => getUserByEmail(setUserAttributes, email));
  useQuery("secteur", () => fetchSecteur(setSecteurAttributes));
  const { isLoading, isError } = useQuery(
    "verificationToken",
    () => verifToken(utilisateurId, token),
    {
      onError: (error) => {
        navigate("/");
      },
    }
  );
   // ✅ Update isMember whenever user changes
  useEffect(() => {
    if (user) {
      setIsMember(isGexMemeber(user));
    }
  }, [user]);

  useEffect(() => {
    console.log("Is GexMember?", isMember);
  }, [isMember]);

  if (isLoading) {
    return (
      <div>
        <center>
          <ProgressSpinner />
        </center>
      </div>
    );
  }
  if (isError) {
    toast.current.show({
      severity: "error",
      summary: "Erreur",
      detail: `Lien est expiré `,
      life: 2000,
    });
    navigate("/");
  }
  
 console.log("Is GexMember?", isMember);
 
 

  //const SecteurTable = Object.entries(secteurs).map(([key, value]) => ({
    //name: value.libelle, 
    //value: value.id_secteur_activite_gexpertise, 
  //}));
  //console.log(SecteurTable)
  

  const OnSubmit = async (data) => {
    CreateNewUser({
      token: token,
      utilisateurId: utilisateurId,
      nom: data.nom,
      prenom: data.prenom,
      entreprise: data.nomSociete,
      password: data.password,
      cgu: data.cgu,
      confirmPassword: data.confirmpassword,
      tel_fixe: data.tel_fixe,
      intitule_poste: data.intitule_poste,
      secteur_activite: data.secteur_activite,
      civilite:data.civilite
    })
      .then(() => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          detail: "Succès d'enregistrement",
          life: 3000,
        });
        navigate("/");
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Token non valide",
          life: 2000,
        });
        console.error(error.response?.data || error.message);
      });
  };

  const validate = (data) => {
    let errors = {};
   

    if (!data.nom) {
      errors.nom = "nom requis.";
    }
    if (!data.prenom) {
      errors.prenom = "prenom requis.";
    }

    if (!data.password) {
      errors.password = "mot de passe requis.";
    }
    if (!data.confirmpassword) {
      errors.confirmpassword = "Confirmer mot de passe requis.";
    }
    if (data.confirmpassword !== data.password) {
      errors.confirmpassword = "mots de passe non identiques.";
    }
    if (!data.cgu) {
      errors.cgu = " -- vous devez accepter les cgu et le RGPD.";
    }

    return errors;
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return (
      isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
    );
  };

  return (
    <div className="cardRegister">
      <Toast ref={toast} />
      <Card>
        <div className="gexonline">
          <img src="/gexonline.png" alt="gexonline" />
        </div>

        <Form
          onSubmit={OnSubmit}
          initialValues={{
            username: email,
            password: "",
            confirmpassword: "",
            cgu: false,
            prenom: user?.prenom ? user?.prenom : "",
            nom: user?.nom ? user?.nom : "",
            nomSociete: user?.entreprise ? user?.entreprise : "",
            tel_fixe: "",
            intitule_poste: "",
            secteur_activite: "",
            civilite: "",
          }}
          validate={validate}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit} className="p-fluid grid">
              <div className="field col-md-12 col-sm-12">
                <Field
                  name="username"
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <span className="p-float-label ">
                        <InputText
                          id="username"
                          disabled
                          {...input}
                          className={classNames({
                            "p-invalid": isFormFieldValid(meta),
                          })}
                        />
                        <label
                          htmlFor="username"
                          className={classNames({
                            "p-error": isFormFieldValid(meta),
                          })}
                        >
                          Adresse mail*
                        </label>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>
              <div className="field col-md-4 col-sm-12">
                <Field
                  format={toUpperCase}
                  parse={toUpperCase}
                  name="nom"
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <span className="p-float-label ">
                        <InputText
                          id="nom"
                          //disabled={user.id_utilisateur_gexpertise ? true : false}
                          disabled
                          {...input}
                          className={classNames({
                            "p-invalid": isFormFieldValid(meta),
                          })}
                        />
                        <label
                          htmlFor="nom"
                          className={classNames({
                            "p-error": isFormFieldValid(meta),
                          })}
                        >
                          NOM*
                        </label>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>
              <div className="field col-md-4 col-sm-12">
                <Field
                  format={capitalizeFirstLetter}
                  parse={capitalizeFirstLetter}
                  name="prenom"
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <span className="p-float-label ">
                        <InputText
                          id="prenom"
                          //disabled={user.id_utilisateur_gexpertise ? true : false}
                          disabled
                          {...input}
                          className={classNames({
                            "p-invalid": isFormFieldValid(meta),
                          })}
                        />
                        <label
                          htmlFor="prenom"
                          className={classNames({
                            "p-error": isFormFieldValid(meta),
                          })}
                        >
                          Prénom*
                        </label>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>
              {!isMember &&(
              <div className="field col-md-4 col-sm-12">
                <Field
                  format={toUpperCase}
                  parse={toUpperCase}
                  name="nomSociete"
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <span className="p-float-label">
                        <InputText
                          id="nomSociete"
                          disabled={user.id_utilisateur_gexpertise ? true : false}
                          hidden={user.id_utilisateur_gexpertise ? true : false}
                          {...input}
                          className={classNames({
                            "p-invalid": isFormFieldValid(meta),
                          })}
                        />
                        <label
                        hidden={user.id_utilisateur_gexpertise ? true : false}
                        
                          htmlFor="nomSociete"
                          className={classNames({
                            "p-error": isFormFieldValid(meta),
                          })}
                        >
                          Nom de la Societe
                        </label>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>)}
              {!user.id_utilisateur_gexpertise &&  !isMember && (
          
              <div className="field col-md-4 col-sm-12">
                
                  <Field
                    name="tel_fixe"
                    render={({ input, meta }) => (
                      <div className="p-field inputTel">
                        <span className="p-label">
                          <label
                            htmlFor="tel_fixe"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          >
                            Téléphone OU Mobile
                          </label>
                          <PhoneInput
                            id="tel_fixe"
                            defaultCountry="FR"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                        </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}
                  />
             
              </div>   )}
              {!user.id_utilisateur_gexpertise && !isMember&&  (
              <div className="field col-md-4 col-sm-12">
                <Field
                  format={toLowerCase}
                  parse={toLowerCase}
                  name="intitule_poste"
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <span className="p-float-label ">
                        <InputText
                          id="intitule_poste"
                          hidden={user.id_utilisateur_gexpertise ? true : false}
                          {...input}
                          className={classNames({
                            "p-invalid": isFormFieldValid(meta),
                          })}
                        />
                        <label
                          htmlFor="intitule_poste"
                          className={classNames({
                            "p-error": isFormFieldValid(meta),
                          })}
                          hidden={user.id_utilisateur_gexpertise ? true : false}
                        >
                          Poste occupé
                        </label>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>)}
              {!user.id_utilisateur_gexpertise &&  !isMember && (
              <div className="field col-md-4 col-sm-12">
  <Field
    name="civilite"
    render={({ input, meta }) => (
      <div className="p-field">
        <span className="p-float-label">
          <Dropdown
            id="civilite"
            value={input.value} 
            hidden={user.id_utilisateur_gexpertise ? true : false}
            onChange={(e) => input.onChange(e.value)} 
            options={[
              { label: "Madame", value: "Madame" },
              { label: "Monsieur", value: "Monsieur" },
              { label: "Autre", value: "Autre" },
            ]}
            placeholder="Choisissez votre civilité"
            className={classNames({
              "p-invalid": isFormFieldValid(meta),
            })}
          />
          <label
            htmlFor="civilite"
            hidden={user.id_utilisateur_gexpertise ? true : false}
            className={classNames({
              "p-error": isFormFieldValid(meta),
            })}
          >
            Civilité*
          </label>
        </span>
        {getFormErrorMessage(meta)}
      </div>
    )}
  />
</div>)}
              {!user.id_utilisateur_gexpertise && !isMember && (
              <div className="field col-md-12 col-sm-12">
                <Field
                
                  name="secteur_activite"
                  
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <span className="p-float-label ">
                      <InputText
                      type="text"
          id="secteur_activite"
          hidden={user.id_utilisateur_gexpertise ? true : false}
          value={input.value} // Bind to the ID (value)
          onChange={(e) => input.onChange(e.target.value)} // Update form state with ID
          className={classNames({
            "p-invalid": isFormFieldValid(meta),
          })}
        />
                        <label
                         hidden={user.id_utilisateur_gexpertise ? true : false}
                          htmlFor="secteur_activite"
                          className={classNames({
                            "p-error": isFormFieldValid(meta),
                          })}
                         
                        >
                          Secteur d'activité
                        </label>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>)}
              <div className="field col-md-6 col-sm-12">
                <Field
                  name="password"
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <span className="p-float-label">
                        <Password
                          id="password"
                          feedback={false}
                          {...input}
                          toggleMask
                          onInput={(e) => setPassword(e.target.value)}
                          className={classNames({
                            "p-invalid": isFormFieldValid(meta),
                          })}
                        />
                        <label
                          htmlFor="password"
                          className={classNames({
                            "p-error": isFormFieldValid(meta),
                          })}
                        >
                          Mot de passe*
                        </label>
                      </span>
                      <PasswordCriteria password={password} />
                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>
              <div className="field col-md-6 col-sm-12">
                <Field
                  name="confirmpassword"
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <span className="p-float-label">
                        <Password
                          id="confirmpassword"
                          feedback={false}
                          {...input}
                          toggleMask
                          className={classNames({
                            "p-invalid": isFormFieldValid(meta),
                          })}
                        />
                        <label
                          htmlFor="confirmpassword"
                          className={classNames({
                            "p-error": isFormFieldValid(meta),
                          })}
                        >
                          confirmer le mot de passe*
                        </label>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>

              <div className="field col-md-12 col-sm-12">
                <Field
                  name="cgu"
                  type="checkbox"
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <span className="p-label">
                        <Checkbox
                          id="cgu"
                          {...input}
                          className={classNames({
                            "p-invalid": isFormFieldValid(meta),
                          })}
                        />
                        <label>
  J'ai pris connaissance des  <a href="/CGUDisconnected" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>
     CGU
  </a> et du RGPD, et je les accepte *
</label>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>
              <div className="btn-regiqter col-md-12 col-sm-12">
                <Button
                  type="submit"
                  label="Enregistrer"
                  className="p-mt-2 enregistrer"
                />
              </div>
            </form>
          )}
        />
      </Card>
    </div>
  );
}

export default InterfaceRegistration;
